module.exports = __webpack_public_path__ + "img/极端降雨.b5440c68.png";